import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// When adding new settings, add them to the initSettings function in
// "settings/actions.js", too.

const state = {
  steps: 0
}

export default {
  state,
  mutations,
  actions,
  getters
}
